import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import '../dashboard.css';
import { useLanguage } from '../../../contexts/LanguageContext';

interface DashCardProps {
  title: string;
  caption?: string;
  /** bootstrap-icons name shown as a tinted chip before the title. */
  icon?: string;
  /** "View all" target. */
  to?: string;
  /** Header without bottom padding — for content that brings its own top spacing. */
  flushHead?: boolean;
  className?: string;
  children?: React.ReactNode;
}

/** White bordered card with the dashboard's title / caption / "view all" header. */
const DashCard: React.FC<DashCardProps> = ({ title, caption, icon, to, flushHead, className, children }) => {
  const { t } = useLanguage();
  return (
    <section className={classNames('dash-card', className)}>
      <div className={classNames('dash-card-head', { 'is-flush': flushHead })}>
        <div className="dash-card-title-block">
          <h2 className="dash-card-title">
            {icon && (
              <span className="dash-chip dash-chip-brand" aria-hidden="true">
                <i className={`bi ${icon}`} />
              </span>
            )}
            {title}
          </h2>
          {caption && <span className="dash-card-caption">{caption}</span>}
        </div>
        {to && (
          <Link to={to} className="dash-card-link">
            {t('viewAll')}
          </Link>
        )}
      </div>
      {children}
    </section>
  );
};

export default DashCard;
